import { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getHolidayById, updateHoliday, createHoliday } from "../../../apis/holidays";
import { missingPopup } from "../../../helperFunctions/missingFieldToast";
import { toastify } from "../../../helperFunctions/toastify";
import DateInput from "../../SharedComponents/DateInput";

export default function AddEditHoliday() {
	const params = useParams();
	const navigate = useNavigate();

	const [values, setValues] = useState({
		name: "",
		description: "",
		eventStartDate: null,
		eventEndDate: null,
	});

	const onChange = (name, value) => {
		setValues((val) => {
			return { ...val, [name]: value };
		});
	};

	const submitForm = async () => {
		if (!values?.name) {
			missingPopup("Name");
			return;
		}
		if (!values?.eventStartDate) {
			missingPopup("Start Date");
			return;
		}
		if (!values?.eventEndDate) {
			missingPopup("End Date");
			return;
		}
		if (values.eventStartDate > values.eventEndDate) {
			toastify("End date should not be earlier than the start date", "error");
			return;
		}

		const data = {
			name: values.name,
			description: values.description,
			eventStartDate: values.eventStartDate,
			eventEndDate: values.eventEndDate,
		};

		if (!params.id) {
			const { result, error } = await createHoliday(data);
			if (error) {
				toastify(error.message, "error");
				return;
			}
			toastify("Holiday created successfully", "success");
			navigate(-1);
		} else {
			const { result, error } = await updateHoliday({
				...data,
				dataId: params.id,
			});
			if (error) {
				toastify(error.message, "error");
				return;
			}
			toastify("Holiday updated successfully", "success");
			navigate(-1);
		}
	};
	const getProgramDetails = async (id) => {
		const { error, result } = await getHolidayById(id);
		if (error) {
			toastify(error.message, "error");
			return;
		}
		setValues({
			...values,
			name: result.data?.name,
			description: result.data?.description,
			eventStartDate: new Date(result.data?.eventStartDate),
			eventEndDate: new Date(result.data?.eventEndDate),
		});
	};

	useEffect(() => {
		if (params?.id) {
			getProgramDetails(params?.id);
		}
	}, [params?.id]);

	return (
		<>
			<div className="mainHeading px-4">
				<h1>
					<i
						className="fa fa-arrow-left cursor-pointer"
						onClick={() => {
							navigate(-1);
						}}
					></i>
					{`${!params.id ? "Add " : "Edit "}`}
					Program
				</h1>
			</div>
			<div className="col-md-6 px-4 pb-3">
				<Form.Group className="">
					<Form.Label className="black-label-text required">
						Name
					</Form.Label>
					<InputGroup className="mb-3 ">
						<Form.Control
							placeholder="Write..."
							onChange={(e) => {
								onChange("name", e.target.value);
							}}
							value={values.name}
						/>
					</InputGroup>
				</Form.Group>
				<Form.Group className="">
					<Form.Label className="black-label-text">
						Description
					</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							as="textarea"
							rows={3}
							placeholder="Write..."
							style={{ resize: "none" }}
							onChange={(e) => {
								onChange("description", e.target.value);
							}}
							value={values.description}
						/>
					</InputGroup>
				</Form.Group>
				<Form.Group>
					<Form.Label className="black-label-text required">
						Start Date
					</Form.Label>
					<DateInput
						className="col-md-6"
						value={values.eventStartDate}
						placeholder="Start Date"
						onChange={(e) => {
							onChange("eventStartDate", e);
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label className="black-label-text required">
						End Date
					</Form.Label>
					<DateInput
						className="col-md-6"
						value={values.eventEndDate}
						placeholder="End Date"
						onChange={(e) => {
							onChange("eventEndDate", e);
						}}
					/>
				</Form.Group>
				<Button
					className="mt-3 addItem"
					onClick={() => {
						submitForm();
					}}
				>
					Submit
				</Button>
			</div>
		</>
	);
}
